var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import { getNestedValue } from '../../utils';
import { guid } from '@progress/kendo-react-common';
var TreeListBooleanEditor = /** @class */ (function (_super) {
    __extends(TreeListBooleanEditor, _super);
    function TreeListBooleanEditor() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._inputId = guid();
        _this.onChange = function (event) {
            if (_this.props.onChange) {
                _this.props.onChange({
                    dataItem: _this.props.dataItem,
                    level: _this.props.level,
                    field: _this.props.field,
                    syntheticEvent: event,
                    value: event.target.checked
                });
            }
        };
        return _this;
    }
    /**
     * @hidden
     */
    TreeListBooleanEditor.prototype.render = function () {
        var defaultRendering = (React.createElement("td", { style: this.props.style, className: this.props.className },
            React.createElement("input", { checked: getNestedValue(this.props.field, this.props.dataItem) || false, id: this._inputId, type: "checkbox", className: "k-checkbox", onChange: this.onChange }),
            React.createElement("label", { className: "k-checkbox-label", htmlFor: this._inputId })));
        return this.props.render ?
            this.props.render.call(undefined, defaultRendering, this.props) :
            defaultRendering;
    };
    return TreeListBooleanEditor;
}(React.Component));
export default TreeListBooleanEditor;
//# sourceMappingURL=TreeListBooleanEditor.js.map